module.exports = __webpack_public_path__ + "img/Mardona-2.be2949ed.webp";